<template>
  <div class="hgroup">
    <h2 class="c-title-level2">
      월별 출고 현황<small class="main-small">(해당 월 기준 1년)</small>
    </h2>
    <!-- 250408 타이틀 수정 -->
    <a
      href="javascript:void(0);"
      class="c-readmore type-round"
      @click="routerCmd()"
    >
      <i class="c-icon icon-plus-black size-xsmall"></i>
      <span class="text">자세히보기</span>
      <!-- 250408 텍스트 수정 -->
    </a>
  </div>

  <div v-if="isMobile" class="month-aggregated">
    <!-- D:
			1. 증가: is-increase
			2. 감소: is-decreased
			3. 동일: is-unchanged
		-->
    <!-- 250408 영역 수정// -->
    <div class="left-tit">
      <span v-if="data.chart.flag == 'A'" class="compared is-decreased"
        >전월대비 {{ data.chart.cnt02 }}건 감소</span
      >
      <span v-if="data.chart.flag == 'B'" class="compared is-unchanged"
        >전월대비 동일</span
      >
      <span v-if="data.chart.flag == 'C'" class="compared is-increase"
        >전월대비 {{ data.chart.cnt02 }}건 증가</span
      >

      <span class="last-month">{{ data.chart.getMonth }}월 출고건수</span>
    </div>
    <!-- //250408 영역 수정 -->
    <span class="result">
      <span class="system">{{ data.chart.cnt01 }}</span
      >건</span
    >
  </div>

  <div class="chart-box">
    <Line :data="data.chart.chartData" :options="data.options"></Line>
  </div>

  <div v-if="!isMobile" class="month-aggregated">
    <!-- D:
			1. 증가: is-increase
			2. 감소: is-decreased
			3. 동일: is-unchanged
		-->
    <!-- 250408 영역 수정// -->
    <div class="left-tit">
      <span v-if="data.chart.flag == 'A'" class="compared is-decreased"
        >전월대비 {{ data.chart.cnt02 }}건 감소</span
      >
      <span v-if="data.chart.flag == 'B'" class="compared is-unchanged"
        >전월대비 동일</span
      >
      <span v-if="data.chart.flag == 'C'" class="compared is-increase"
        >전월대비 {{ data.chart.cnt02 }}건 증가</span
      >

      <span class="last-month">{{ data.chart.getMonth }}월 출고건수</span>
    </div>
    <!-- //250408 영역 수정 -->
    <span class="result">
      <span class="system">{{ data.chart.cnt01 }}</span
      >건</span
    >
  </div>
</template>

<script setup name="LineChart">
import { defineProps, reactive, watch } from "vue";

import { Line } from "vue-chartjs";
import { useRouter } from "vue-router";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();

const router = useRouter();

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const data = reactive({
  chart: {
    type: "line",
    year: [],
    getMonth: "", //현재 월
    cnt01: "", //현재 월 출고 건
    cnt02: "", //현재 월 - 전 월 출고 건
    flag: "", //전월대비 감소/동일/증가 표기
    chartData: {
      labels: [],
      datasets: [
        {
          data: [],
          titleColor: "#000000",
          borderColor: "rgba(0, 125, 108, 0.5)",
          backgroundColor: function (context) {
            const chart = context.chart;
            const { ctx, chartArea } = chart;

            if (!chartArea) {
              return null;
            }

            const gradient = ctx.createLinearGradient(
              0,
              chartArea.top,
              0,
              chartArea.bottom
            );
            gradient.addColorStop(0, "rgba(0, 125, 108, 0.3)");
            gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

            return gradient;
          },
          fill: true,
          tension: 0,
          borderWidth: 3,
          pointRadius: 3,
          pointBackgroundColor: "#007D6C",
          pointBorderWidth: 0,
        },
      ],
    },
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 60,
        left: 0,
        right: isMobile.value == true ? 15 : 0,
        bottom: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        position: "average",
        yAlign: "bottom",
        caretPadding: 10,
        backgroundColor: "#FFECEC",
        titleColor: "#FF7A7A",
        bodyColor: "#FF7A7A",
        borderColor: "#FFCECE",
        borderWidth: 1,
        padding: 6,
        displayColors: false,
        titleFont: {
          weight: "bold",
        },
        bodyFont: {
          weight: "bold",
        },
        callbacks: {
          title: function (context) {
            const month = context[0].label;
            const year = data.chart.year[context[0].dataIndex];
            return `${year}년${month}월`;
          },
          label: function (context) {
            // 값을 천 단위 구분자로 포맷팅
            const formattedValue = context.formattedValue;
            const totalSum = data.chart.sum[context.dataIndex];
            return `${formattedValue}건(${totalSum})`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: true,
          autoSkipPadding: 10,
          color: "#000000",
          font: {
            size: 15,
          },
        },
      },
      y: { /* 250408 수정 */
        beginAtZero: true,
        ticks: {
          color: '#000000'
        }
      },
    },
  },
});

watch(
  () => (data.chart = props.data),
  () => {
    //전월대비 출고 건 및 현재 월/ 출고 건건 추출
    if (props.data.sysData != null) {
      data.chart.getMonth = props.data.sysData[2];
      data.chart.cnt01 = props.data.sysData[1].toLocaleString();

      if (props.data.sysData[0] > props.data.sysData[1]) {
        data.chart.flag = "A"; //감소
        data.chart.cnt02 = parseInt(
          props.data.sysData[0] - props.data.sysData[1]
        ).toLocaleString();
      } else if (props.data.sysData[0] == props.data.sysData[1]) {
        data.chart.flag = "B"; //동급
        // data.chart.cnt02 = parseInt(
        //   props.data.sysData[1] - props.data.sysData[0]
        // ).toLocaleString();
      } else if (props.data.sysData[0] < props.data.sysData[1]) {
        data.chart.flag = "C"; //증가
        data.chart.cnt02 = parseInt(
          props.data.sysData[1] - props.data.sysData[0]
        ).toLocaleString();
      }
    }
  }
);

/**********************
 * 화면 이동 모음
 *********************/
async function routerCmd() {
  router.push({
    name: "/paintpro/orderList/shipmentList",
  });
}
</script>
